const bannerMessages = [
  {
    sourceLanguage: "bteq",
    targetLanguage: "pyspark",
    value: "bteq-pyspark",
    message: "Efficient code conversion, rigorously tested for optimal results.",
    variant: "success"
  },
  {
    sourceLanguage: "COBOL",
    targetLanguage: "Java",
    value: "cobol-java",
    message: "Efficient code conversion, rigorously tested for optimal results.",
    variant: "success"
  },
  {
    sourceLanguage: "ASP",
    targetLanguage: "React",
    message: "Evolving code conversion, regularly updated and continuously improved.",
    variant: "error"
  },
  {
    sourceLanguage: "React",
    targetLanguage: "Angular",
    value: "React-angular",
    message: "Evolving code conversion, regularly updated and continuously improved.",
    variant: "error"
  },
  {
    sourceLanguage: "C%2B%2B",
    targetLanguage: "Go",
    value: "c++-go",
    message: "Evolving code conversion, regularly updated and continuously improved.",
    variant: "error"
  },
  {
    sourceLanguage: "C%2B%2B",
    targetLanguage: "Rust",
    value: "c++-rust",
    message: "Enhanced code conversion with human-in-the-loop for testing and refinement.",
    variant: "warning"
  },
  {
    sourceLanguage: "C",
    targetLanguage: "Rust",
    value: "c-rust",
    message: "Evolving code conversion, regularly updated and continuously improved.",
    variant: "error"
  },
  {
    sourceLanguage: "python",
    targetLanguage: "C%2B%2B",
    value: "python-c++",
    message: "Enhanced code conversion with human-in-the-loop for testing and refinement.",
    variant: "warning"
  },
  {
    sourceLanguage: "Java",
    targetLanguage: "Angular",
    message: "Evolving code conversion, regularly updated and continuously improved.",
    variant: "error"
  },
]

export default bannerMessages;